import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { addProductsByIsbnsToCart } from './addProductsByIsbnsToCart';
import { bulkUpdateToCart } from './bulkUpdateToCart';
import { SOURCE_CATALOGUE } from '../../store/constants';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { BulkAddByIsbnsToShoppingCartResponse } from '../../store/api';
import { useNotification } from '../../app-store/notification/useNotification';

type Props = {
    isbns: string;
    performChecks: boolean;
};

export const useAddProductsByIsbnsToCart = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const { showNotificationWithInfo } = useNotification();

    return {
        isLoading,
        addByIsbnsToCartBulk: ({ isbns, performChecks }: Props) => {
            const apiCallback = () => addProductsByIsbnsToCart({ isbns, params: { performChecks } });

            return bulkUpdateToCart({
                setLoading,
                performChecks,
                source: SOURCE_CATALOGUE,
                apiCallback,
                notificationMessage: (data: BulkAddByIsbnsToShoppingCartResponse) =>
                    t('notifications.addByIsbnsBulkToCart.success', { count: data.addedIsbnCopyAmount }),
                t,
                onSuccess: () => {
                    invalidateCartAggregations().then();
                    invalidateCartGroupedItems().then();
                    invalidateShoppingCartProducts().then();
                },
                productSelection: undefined,
                showNotificationWithInfo
            });
        }
    };
};
